export default "__VITE_ASSET__BSq66fK7__"